import { Request, requestNoToken } from '../utils';

export const generatePdf = async (data) => {
  const result = await Request.get('metadata/generate-pdf', data);
  return result;
};
